var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-514ab153.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-d8694455.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M15.601 9.465a.5.5 0 0 0 .8 0l1.4-1.866a.5.5 0 0 1 .521-.185l1.174.293a.5.5 0 0 1 .136.914l-1.902 1.14a.5.5 0 0 0-.19.653l.214.427a.5.5 0 0 0 .713.2l4.142-2.602c.49-.308 1.025.325.638.757L22.08 10.5a.5.5 0 0 0 .372.833h.414a.5.5 0 0 1 .278.916l-1.32.883a.5.5 0 0 0-.087.758l1.252 1.334a.5.5 0 0 1-.44.837l-1.947-.294a.5.5 0 0 0-.469.802l1.72 2.2c.329.419-.14.993-.617.755l-3.114-1.555a.462.462 0 0 0-.552.72l1.287 1.453a.5.5 0 0 1-.216.806l-1.089.362a.5.5 0 0 0-.305.287l-.782 1.928a.5.5 0 0 1-.927 0l-.783-1.928a.5.5 0 0 0-.305-.287l-1.088-.362a.5.5 0 0 1-.217-.806l1.287-1.453a.462.462 0 0 0-.552-.72l-3.114 1.555c-.477.238-.946-.336-.617-.756l1.72-2.199a.5.5 0 0 0-.468-.802l-1.949.294a.5.5 0 0 1-.439-.837l1.252-1.334a.5.5 0 0 0-.086-.758l-1.32-.883a.5.5 0 0 1 .278-.916h.413a.5.5 0 0 0 .372-.833L8.755 9.196c-.387-.431.148-1.065.638-.757l4.142 2.601a.5.5 0 0 0 .714-.2l.213-.426a.5.5 0 0 0-.19-.652l-1.902-1.14a.5.5 0 0 1 .137-.915l1.173-.293a.5.5 0 0 1 .521.185l1.4 1.866Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagAlb = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagAlb_default = SvgFlagAlb;
export {
  FlagAlb_default as default
};
